import { useEffect, useState } from "react";
import { Reveal } from "@/components/Reveal";
import WaitlistForm from "@/components/WaitlistForm";
import USMap from "@/components/USMap";
import { api } from "@/lib/api";
import { useSiteConfig } from "@/context/SiteConfigContext";

export default function LaunchLocation() {
  const { config } = useSiteConfig();
  const t = config.t.launch;
  const [markers, setMarkers] = useState([]);
  useEffect(() => {
    api.get("/map/demand").then((r) => setMarkers(r.data)).catch(() => {});
  }, []);

  return (
    <section id="launch-location" className="bg-[#FAFAFC] py-28 sm:py-36" data-testid="launch-location-section">
      <div className="mx-auto max-w-6xl px-6">
        <Reveal className="text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-brand">{t.eyebrow}</p>
          <h2 className="mx-auto mt-4 max-w-3xl text-4xl font-bold tracking-tighter text-neutral-900 sm:text-5xl lg:text-6xl">
            {t.heading}
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-neutral-500">
            {t.paragraph}
          </p>
        </Reveal>

        <div className="mt-16 grid items-center gap-12 lg:grid-cols-[1.3fr_1fr]">
          <Reveal className="relative overflow-hidden rounded-3xl border border-black/5 bg-white p-4 shadow-sm sm:p-8">
            <p className="mb-2 text-center text-sm font-semibold text-neutral-400">People waiting across the U.S.</p>
            <USMap markers={markers} />
          </Reveal>

          <Reveal delay={0.1} className="rounded-3xl border border-black/5 bg-white p-6 shadow-sm sm:p-8">
            <h3 className="text-xl font-bold tracking-tight text-neutral-900">{t.formTitle}</h3>
            <p className="mb-5 mt-1 text-sm text-neutral-500">{t.formSubtitle}</p>
            <WaitlistForm
              source="launch"
              showType={false}
              cta="Request My City"
              successMsg="Your city is on the list. We'll let you know when SOSConnect AI is getting closer to your area."
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
